<template>
    <rkm-area
        title="Últimos atendimentos"
        no-margin-top
    >
        <template slot="trailing">
            <rkm-button
                @click="$refs.Modal.open()"
                color="primary"
                small
            >
                Ver mais
            </rkm-button>
        </template>

        <List :data="data" :limit="limit" />

        <Modal
            :data="data"
            ref="Modal"
        />
    </rkm-area>
</template>

<script>
// Components.
import List from './List'
import Modal from './components/Modal'

export default {
    components: { List, Modal },
    props: {
        data: { type: Object, required: true },
        limit: { type: Number, default: 3 },
    },
}
</script>